'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */
///* global */
/*jshint -W084 */

/*
 * @author      : 绝云（wensen.lws）
 * @description : 获取／设置 dom 元素的属性
 */

var bomUtils = require('zero-bom/utils');
var stringUtils = require('zero-lang/string');
var checkType = require('zero-lang/type');

var domStyle = require('./style');
var domConstruct = require('./construct');
var domQuery = require('./query');
var domUtils = require('./utils');

var ieVersion = bomUtils.versions.msie;
var propNames = {
    'class': 'className',
    'for': 'htmlFor',
    tabindex: 'tabIndex',
    readonly: 'readOnly',
    colspan: 'colSpan',
    frameborder: 'frameBorder',
    rowspan: 'rowSpan',
    textcontent: 'textContent',
    valuetype: 'valueType'
};
var forcePropNames = {
    innerHTML: 1,
    textContent: 1,
    className: 1,
    htmlFor: !!ieVersion,
    value: 1
};
var attrNames = {
    classname: 'class',
    htmlfor: 'for',
    tabindex: 'tabIndex',
    readonly: 'readOnly'
};

function hasAttr(node, name) {
    var attr = node.getAttributeNode && node.getAttributeNode(name);
    return !!attr && attr.specified;
}
function getText(node) {
    var text = '';
    var ch = node.childNodes;
    for (var i = 0, n; n = ch[i]; i++) {
        //Skip comments.
        if (n.nodeType !== 8) {
            if (n.nodeType === 1) {
                text += getText(n);
            } else {
                text += n.nodeValue;
            }
        }
    }
    return text;
}
function getProp(node, name) {
    var lc = name.toLowerCase();
    var propName = propNames[lc] || name;
    if (propName === 'textContent' && !domUtils.hasTextContent) {
        return getText(node);
    }
    return node[propName]; // Anything
}
function setProp(node, name, value) {
    var l = arguments.length;
    if (l === 2 && !checkType.isString(name)) {
        // inline'd type check
        // the object form of setter: the 2nd argument is a dictionary
        for (var x in name) {
            setProp(node, x, name[x]);
        }
        return node; // DomNode
    }
    var lc = stringUtils.lc(name);
    var propName = propNames[lc] || name;
    if (propName === 'style' && !checkType.isString(value)) {
        // inline'd type check
        // special case: setting a style
        domStyle.set(node, value);
        return node; // DomNode
    }
    if (propName === 'innerHTML') {
        if (ieVersion && stringUtils.lc(node.tagName) in {
            col: 1,
            colgroup: 1,
            table: 1,
            tbody: 1,
            tfoot: 1,
            thead: 1,
            tr: 1,
            title: 1
        }) {
            domConstruct.empty(node);
            node.appendChild(domConstruct.toDom(value, node.ownerDocument));
        } else {
            node[propName] = value;
        }
        return node; // DomNode
    }
    if (propName === 'textContent' && !domUtils.hasTextContent) {
        domConstruct.empty(node);
        node.appendChild(node.ownerDocument.createTextNode(value));
        return node;
    }
    node[propName] = value;
    return node;
}

var domAttr = {
    has: function has(node, name) {
        var lc = stringUtils.lc(name);
        return forcePropNames[propNames[lc] || name] || hasAttr(domQuery.one(node), attrNames[lc] || name);
    },
    get: function get(node, name) {
        node = domQuery.one(node);
        var lc = stringUtils.lc(name);
        var propName = propNames[lc] || name;
        var forceProp = forcePropNames[propName];
        var value = node[propName];
        var attrName = undefined; // should we access this attribute via a property or via getAttribute()?

        if (forceProp && !checkType.isUndefined(value)) {
            // node's property
            return value; // Anything
        }

        if (propName === 'textContent') {
            return getProp(node, propName);
        }

        if (propName !== 'href' && (checkType.isBoolean(value) || checkType.isFunction(value))) {
            // node's property
            return value; // Anything
        }
        // node's attribute
        // we need _hasAttr() here to guard against IE returning a default value
        attrName = attrNames[lc] || name;
        return hasAttr(node, attrName) ? node.getAttribute(attrName) : null; // Anything
    },
    set: function set(node, name, value) {
        node = domQuery.one(node);
        if (arguments.length === 2) {
            // inline'd type check
            // the object form of setter: the 2nd argument is a dictionary
            for (var x in name) {
                domAttr.set(node, x, name[x]);
            }
            return node; // DomNode
        }
        var lc = name.toLowerCase();
        var propName = propNames[lc] || name;
        var forceProp = forcePropNames[propName];
        if (propName === 'style' && checkType.isString(value)) {
            // inline'd type check
            // special case: setting a style
            domStyle.set(node, value);
            return node; // DomNode
        }
        if (forceProp || checkType.isBoolean(value) || checkType.isFunction(value)) {
            return setProp(node, name, value);
        }
        // node's attribute
        node.setAttribute(attrNames[lc] || name, value);
        return node; // DomNode
    },
    remove: function remove(node, name) {
        domQuery.one(node).removeAttribute(attrNames[stringUtils.lc(name)] || name);
    },
    getNodeProp: function getNodeProp(node, name) {
        node = domQuery.one(node);
        var lc = stringUtils.lc(name);
        var propName = propNames[lc] || name;
        var attrName = undefined;
        if (propName in node && propName !== "href") {
            // node's property
            return node[propName]; // Anything
        }
        // node's attribute
        attrName = attrNames[lc] || name;
        return hasAttr(node, attrName) ? node.getAttribute(attrName) : null; // Anything
    }
};

module.exports = domAttr;


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-dom/attr.js
 ** module id = 49
 ** module chunks = 0
 **/